import * as type from './types';

export function loginOtpResend(data) {
    return {
        type: type.POST_OTP_LOGIN_RESEND_OTP_REQUESTED,
        data: data,
    }
}

export function clearLoginOtpResendError() {
    return {
        type: type.CLEAR_LOGIN_OTP_RESEND_ERROR,
    }
}